/** Slugs for /dating-{slug} — keys must match landing.cities.* in resources/lang/viluu/{locale}/landing.php */
export const CITY_REGIONS = [
  {
    key: 'de',
    nameKey: 'landing.discover.region_de',
    slugs: [
      'berlin',
      'hamburg',
      'muenchen',
      'koeln',
      'frankfurt',
      'stuttgart',
      'duesseldorf',
      'leipzig',
      'dresden',
      'nuernberg',
    ],
  },
  {
    key: 'at',
    nameKey: 'landing.discover.region_at',
    slugs: ['wien', 'graz', 'salzburg'],
  },
  {
    key: 'ch',
    nameKey: 'landing.discover.region_ch',
    slugs: ['zuerich', 'basel', 'bern'],
  },
];

export const CITY_SLUGS = CITY_REGIONS.flatMap((r) => r.slugs);

export const cityTitleKey = (slug) => `landing.cities.${slug}.title`;

/** Cross-links between city pages (locale-independent slugs). */
export const CITY_RELATED = {
  basel: ['bern', 'berlin', 'hamburg', 'muenchen', 'koeln', 'frankfurt'],
  berlin: ['hamburg', 'muenchen', 'koeln', 'frankfurt', 'stuttgart', 'duesseldorf'],
  bern: ['berlin', 'hamburg', 'muenchen', 'koeln', 'frankfurt', 'stuttgart'],
  dresden: ['nuernberg', 'wien', 'graz', 'salzburg', 'zuerich', 'basel'],
  duesseldorf: ['leipzig', 'dresden', 'nuernberg', 'wien', 'graz', 'salzburg'],
  frankfurt: ['stuttgart', 'duesseldorf', 'leipzig', 'dresden', 'nuernberg', 'wien'],
  graz: ['salzburg', 'zuerich', 'basel', 'bern', 'berlin', 'hamburg'],
  hamburg: ['muenchen', 'koeln', 'frankfurt', 'stuttgart', 'duesseldorf', 'leipzig'],
  koeln: ['frankfurt', 'stuttgart', 'duesseldorf', 'leipzig', 'dresden', 'nuernberg'],
  leipzig: ['dresden', 'nuernberg', 'wien', 'graz', 'salzburg', 'zuerich'],
  muenchen: ['koeln', 'frankfurt', 'stuttgart', 'duesseldorf', 'leipzig', 'dresden'],
  nuernberg: ['wien', 'graz', 'salzburg', 'zuerich', 'basel', 'bern'],
  salzburg: ['zuerich', 'basel', 'bern', 'berlin', 'hamburg', 'muenchen'],
  stuttgart: ['duesseldorf', 'leipzig', 'dresden', 'nuernberg', 'wien', 'graz'],
  wien: ['graz', 'salzburg', 'zuerich', 'basel', 'bern', 'berlin'],
  zuerich: ['basel', 'bern', 'berlin', 'hamburg', 'muenchen', 'koeln'],
};

export const CITY_HAS_EXTRA = new Set([
  'basel',
  'bern',
  'dresden',
  'duesseldorf',
  'frankfurt',
  'graz',
  'leipzig',
  'nuernberg',
  'salzburg',
  'stuttgart',
  'wien',
]);
